/**
 *
 * @param {string} memberType
 * @param {Object} members
 * @return {function(module: angular.Module)}
 */
export function ngModuleRegistrar(memberType, members) {

    /**
     * @param {angular.Module} module
     */
    return (module) => {

        Object.keys(members)
              .forEach((name) => {

                  module[ memberType ](name, members[ name ]);
              });
    };
}

/**
 * @param {Object} provider
 * @param {Function} service
 * @param {...string} providerProperties
 * @returns {Function}
 */
export function getProviderFactoryForService(provider, service, ...providerProperties) {

    const factory = function (...di) {

        const options = providerProperties.map((name) => provider[ name ]);

        service = new service(...di, ...options);

        if (service instanceof Injectable) {

            providerProperties.forEach((name, i) => {

                service[ name ] = options[ i ];
            });
        }

        return service;
    };

    factory.$inject = service.$inject || [];

    return factory;
}

export class Injectable {

    static get $inject() {

        return [];
    }

    /**
     * @param {*[]} injected
     */
    assignInjected(injected) {

        this.constructor
            .$inject
            .forEach((name, i) => {

                this[ name ] = injected[ i ];
            });
    }

    constructor(...injected) {

        this.assignInjected(injected);
    }
}

export class AbstractComponentController extends Injectable {

    constructor(...injected) {

        super(...injected);

        this.$destroyWorkers = [];
    }

    $onDestroy() {

        if (!this.$destroyWorkers.length) {

            return;
        }

        this.$destroyWorkers.forEach((worker) => worker());
    }
}

export class AbstractComponentModalController extends AbstractComponentController {

    static get $inject() {

        return [
            '$uibModal',
            '$transitions',
        ];
    }

    static get bindings() {

        return {
            resolve: '<',
            close: '&',
            dismiss: '&'
        };
    }

    constructor(...injected) {

        super(...injected);
        this.$transitions.onBefore({}, () => this.cancel());
    }

    cancel() {

        this.dismiss({$value: 'cancel'});
    }
}

export class EventEmitter {

    /**
     * @param {string} eventName
     * @returns {string}
     * @protected
     */
    eventName(eventName) {

        return `${this.prefix}${eventName}`;
    }

    /**
     * @param {Scope} $rootScope
     * @param {string} prefix
     */
    constructor($rootScope, prefix = "") {

        /**
         * @protected
         * @type {Scope}
         */
        this.$rootScope = $rootScope;

        /**
         * @protected
         * @type {string}
         */
        this.prefix = `${prefix}`;
    }

    /**
     * @param {string} eventName
     * @param {...*} params
     */
    emit(eventName, ...params) {

        this.$rootScope.$emit(this.eventName(eventName), ...params);
    }

    /**
     * @param {string} eventName
     * @param {function(...*)} listener
     * @return {function}
     */
    on(eventName, listener) {

        return this.$rootScope.$on(this.eventName(eventName), (event, ...args) => listener(...args));
    }

    /**
     * @param {string} eventName
     * @param {function(...*)} listener
     * @return {function}
     */
    once(eventName, listener) {

        const deRegister = this.$rootScope.$on(this.eventName(eventName), (event, ...args) => {

            deRegister();

            return listener(...args);
        });

        return deRegister;
    }

    /**
     * @param {...{name: string, listener: function}} subscribers
     * @returns {function}
     */
    either(...subscribers) {

        const deRegistrars = subscribers.map(({name, listener}) => {

            return this.once(name, (...args) => {

                deRegister();

                listener(...args);
            });
        });

        return deRegister;

        function deRegister() {

            deRegistrars.forEach((deRegistrar) => deRegistrar());
        }
    }
}

export function dataURLToFile(dataURL, fileName, options = {}) {

    const byteString = dataURL.split(',')[0].indexOf('base64') >= 0 ? window.atob(dataURL.split(',')[1]) : decodeURIComponent(dataURL.split(',')[1]);
    const ia = new Uint8Array(byteString.length);

    const blob = new Blob([ia.map((x, i) => byteString.charCodeAt(i))], options);

    return new File([blob], fileName, options);
}

function wrongAppVersionModal($uibModal, $translate) {

    if (!($uibModal && $translate)) {

        return false;
    }

    return $uibModal.open({
        component: 'infoModal',
        resolve: {
            title: () => $translate.instant('INFORMATION'),
            message: () => $translate.instant('WE_HAVE_DETECTED_THAT_YOU_ARE_NOT_USING_THE_LATEST_VERSION_OF_MABEET_YOUR_PAGE_WILL_BE_REFRESHED'),
        }
    }).result.finally(() => location.reload());
}

export function lazyLoadModule(lazyModuleClosure) {

    return $transitions => {

        const injector = $transitions.injector();

        const $ocLazyLoad = injector.get('$ocLazyLoad');
        const $uibModal = injector.get('$uibModal');
        const $translate = injector.get('$translate');

        return lazyModuleClosure()
            .then(mod => $ocLazyLoad.load(mod.default))
            .catch(err => {

                wrongAppVersionModal($uibModal, $translate);

                throw new Error(err);
            });
    };
}



// WEBPACK FOOTER //
// ./src/helpers/angular.js